<script setup lang="ts">
const carousels = [
  {
    title: 'Logam Mulia Emas',
    description:
      'Hadiah utama berupa logam mulia Antam 1 gram yang bisa kamu dapatkan dengan rutin kirim paket.',
    image_url: '/assets/batch-2/poin/1ka.webp'
  },
  {
    title: 'Pulsa & Token Listrik',
    description:
      'Kebutuhan sehari-hari seperti Pulsa dan Token Listrik juga tersedia untuk kamu tukarkan kapan saja.',
    image_url: '/assets/batch-2/poin/2ka.webp'
  },
  {
    title: 'Voucher Ongkir',
    description:
      'Pengeluaran untuk kirim paket jadi lebih hemat dengan Voucher Potongan Ongkir hingga Rp100.000.',
    image_url: '/assets/batch-2/poin/3ka.webp'
  },
  {
    title: 'Merchandise Eksklusif',
    description:
      'Jangan sampai kehabisan hadiah merchandise eksklusif KiriminAja khusus untuk semua member setia.',
    image_url: '/assets/batch-2/poin/4ka.webp'
  },
  {
    title: 'Peralatan Pengiriman',
    description:
      'Dapatkan hadiah peralatan pengiriman seperti lakban dan printer thermal untuk bantu pengemasan paket.',
    image_url: '/assets/batch-2/poin/5ka.webp'
  }
]
</script>

<template>
  <section class="bg-surface-container-low">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle
        class="text-center"
        title="Semakin Banyak Poin, Semakin Besar Hadiahnya"
      />

      <div class="w-full grid lg:grid-cols-5 gap-3">
        <div
          v-for="(item, key) in carousels"
          :key="key"
          class="h-full p-4 rounded-2xl overflow-hidden shadow-sm bg-background dark:bg-surface-container-high text-on-surface flex flex-col gap-3"
        >
          <div
            class="bg-gradient-to-b from-primary to-on-primary-container rounded-lg overflow-hidden"
          >
            <NuxtImg
              :src="item.image_url"
              class="w-full aspect-square"
              :alt="item.title"
            />
          </div>
          <div class="flex flex-col gap-1">
            <p class="text-lg font-display font-semibold">{{ item.title }}</p>
            <p class="text-sm text-on-surface-variant">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>

      <CtaBase />
    </UiContainer>
  </section>
</template>
